import { BrightRiverShotConfirmation } from "./bright-river-shot-confirmation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useState } from "react";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useBrightRiverImages } from "../hooks/use-bright-river-images";
import { useQaNavActions } from "shared/hooks/use-qa-nav-actions";
import { TaskContext } from "contexts/task";
import { ShotContext } from "../context";
import classnames from "classnames";

export const PhotoQaConfirmation = (props) => {
    const { task } = useContext(TaskContext);
    const { shotsByLocale } = useContext(ShotContext);
    const corrections = useBrightRiverImages(shotsByLocale);
    const [canCompleteTask, setCompleteTask] = useState(true);
    const sourcePage = task.sourcePage;
    const { isBusy, finishTask } = useQaNavActions({ ...props, task, sourcePage });
    const completeIcon = props.acceptPayload && props.acceptPayload.icon ? props.acceptPayload.icon : faCheck;

    // can be memoized but remember about passing correct deps
    const handleEditedImagesConfirmation = ({ isEditComplete }) => {
        if (isEditComplete) {
            finishTask();
        }

        setCompleteTask(true);
    };

    const handleCompleteTask = (e) => {
        e.preventDefault();

        if (corrections.length) {
            setCompleteTask(false);

            return;
        }

        finishTask();
    };

    return (
        <>
            <BrightRiverShotConfirmation corrections={corrections} show={!canCompleteTask} onEditComplete={handleEditedImagesConfirmation} />
            <div className="task-nav">
                <div className="button-group -right">
                    <button
                        className={classnames("button -primary", { "-disabled": isBusy || props.isDirty || props.isReadOnly })}
                        onClick={handleCompleteTask}
                        title="Complete Task"
                        disabled={isBusy || props.isReadOnly}
                    >
                        <FontAwesomeIcon icon={completeIcon} />
                    </button>
                </div>
            </div>
        </>
    );
};
